import { httpClient } from "./httpClient";

const getAllGroupLevelsByIdCompany = (idCompany) => {
  if (idCompany) {
    return httpClient.get(`group-levels/company/${idCompany}`);
  } else {
    return httpClient.get(`group-levels/company`);
  }
};

const updateGroupLevel = (data, idCompany) => {
  if (idCompany) {
    return httpClient.put(`group-level/company/${idCompany}`, data);
  } else {
    return httpClient.put(`group-level/company`, data);
  }
};

const updateLevel = (data, idCompany) => {
  if (idCompany) {
    return httpClient.put(`level/company/${idCompany}`, data);
  } else {
    return httpClient.put(`level/company`, data);
  }
};

const createEmployeePersonnelLevel = (formData) => {
  return httpClient.post(`/employee-personnel-level`, formData);
};

const getEmployeePersonnelLevelById = (idEmployeePersonnelLevel, query) => {
  return httpClient.get(`/employee-personnel-level/${idEmployeePersonnelLevel}`, { params: query });
};

const updateEmployeePersonnelLevel = (idEmployeePersonnelLevel, formData) => {
  return httpClient.put(`/employee-personnel-level/${idEmployeePersonnelLevel}`, formData);
};

const deleteEmployeePersonnelLevel = (idEmployeePersonnelLevel) => {
  return httpClient.delete(`/employee-personnel-level/${idEmployeePersonnelLevel}`);
};

const getAllGroupLevelByIdVendor = (idVendor) => {
  return httpClient.get(`/group-level/vendor/${idVendor}`);
};

export default {
  getAllGroupLevelsByIdCompany,
  updateGroupLevel,
  updateLevel,
  createEmployeePersonnelLevel,
  getEmployeePersonnelLevelById,
  updateEmployeePersonnelLevel,
  deleteEmployeePersonnelLevel,
  getAllGroupLevelByIdVendor,
};